import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import * as React from 'react';
import { getCategoriesData, getTagsDataBySlugs } from '../../api/api';
import { Category, dtoToCategoryProps } from './category';
import { FetchStatus } from '../view-rapper';
import { biLogger } from '../../bi';
import { config } from '../../config';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { WithFetcher, } from '../../component-decorators/with-fetcher';
import { composer } from '../../component-decorators/composer';
import { CenteredLoader } from '../centered-loader';
import { ErrorPageType, Origin } from '../..';
import { CategorySEO } from './category-seo';
import { useConfigContext } from '../../config-context';
import { ErrorPageContainer } from '../error-page/error-page-container';
import { getReferralInfo, getWidgetReferral } from '../../common/bi-events';
import { withExperiments } from '../../component-decorators/with-experiments';
var initialCategoryFetch = function (slug, subCategories, experiments, locale, countryCode, rpcClient) {
    var useInReview = experiments && experiments.enabled('specs.marketplace.UseInReview');
    if (subCategories && subCategories.length > 0) {
        return function () {
            return Promise.all([
                getCategoriesData(locale, rpcClient),
                getTagsDataBySlugs([slug], useInReview, locale, countryCode, true, true, rpcClient),
                getTagsDataBySlugs(subCategories, useInReview, locale, countryCode, true, true, rpcClient),
            ]);
        };
    }
    return function () {
        return Promise.all([
            getCategoriesData(locale, rpcClient),
            getTagsDataBySlugs([slug], useInReview, locale, countryCode, true, true, rpcClient),
        ]);
    };
};
var getNameForTitle = function (data, subCategories) {
    var _a, _b, _c, _d, _e, _f;
    // if we have only one sub category- it should be the title for SEO
    if (subCategories && subCategories.length === 1) {
        var subCatData = (_b = (_a = data === null || data === void 0 ? void 0 : data[1]) === null || _a === void 0 ? void 0 : _a.tagsAndSubCategories) === null || _b === void 0 ? void 0 : _b[0].subCategories.find(function (cat) { return cat.slug === subCategories[0]; });
        return subCatData === null || subCatData === void 0 ? void 0 : subCatData.name;
    }
    return (_f = (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data[1]) === null || _c === void 0 ? void 0 : _c.tagsAndSubCategories) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.tag) === null || _f === void 0 ? void 0 : _f.name;
};
var isValidCategoryData = function (fetchData) {
    return (fetchData &&
        fetchData[1] &&
        fetchData[1].tagsAndSubCategories &&
        fetchData[1].tagsAndSubCategories[0]);
};
export var CategoryFetcher = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var slug = _a.slug, subCategories = _a.subCategories, experiments = _a.experiments, t = _a.t;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, countryCode = _b.countryCode, rpcClient = _b.rpcClient;
    console.log("marketplace-component/src/components/category/category-container.tsx file - line 116 - " + Date.now());
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: initialCategoryFetch(slug, subCategories, experiments, locale, countryCode, rpcClient), fetchMemoizationId: "category-" + slug + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        return (React.createElement(CategoryContainerWrapper, { slug: slug, subCategories: subCategories, experiments: experiments, locale: locale, countryCode: countryCode, fetchData: fetchData, reFetch: reFetch, t: t }));
    }));
});
var CategoryContainerWrapper = function (_a) {
    var slug = _a.slug, subCategories = _a.subCategories, experiments = _a.experiments, locale = _a.locale, countryCode = _a.countryCode, fetchData = _a.fetchData, reFetch = _a.reFetch, t = _a.t;
    return isValidCategoryData(fetchData) ? (React.createElement(React.Fragment, null,
        config.origin === Origin.STANDALONE && (React.createElement(CategorySEO, { categoryName: getNameForTitle(fetchData, subCategories), categoryDesc: fetchData[1].tagsAndSubCategories[0].tag.description, subCategoriesCount: subCategories ? subCategories.length : 0, categorySlug: slug })),
        React.createElement(CategoryContainer, { slug: slug, subCategories: subCategories, fetchData: fetchData, reFetch: reFetch, t: t, locale: locale, countryCode: countryCode }))) : (React.createElement(ErrorPageContainer, { slug: slug, errorPageType: ErrorPageType.NOT_FOUND }));
};
var CategoryContainer = /** @class */ (function (_super) {
    __extends(CategoryContainer, _super);
    function CategoryContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.sendPageViewBi = function (dto) {
            var pageViewParams = {
                app_id: null,
                market: config.originForBI,
                navigation_source: _this.props.marketplaceStore.route.referral,
                // pageType: 'category-page',
                tag_name: dto.tagsAndSubCategories[0].tag.slug.replace(/-/g, '_'),
                tag_type: dto.tagsAndSubCategories[0].tag.type.toLowerCase(),
                msid: _this.props.marketplaceStore.metaSiteId,
                referral_info: getReferralInfo(_this.props.marketplaceStore.route &&
                    _this.props.marketplaceStore.route.referral, _this.props.marketplaceStore.prevRoute),
                search_term: _this.props.marketplaceStore.prevRoute &&
                    _this.props.marketplaceStore.prevRoute.query,
                widget_referral: getWidgetReferral(),
            };
            biLogger.appMarketPageView(pageViewParams);
        };
        _this.state = { isFetchingData: FetchStatus.FETCHING };
        console.log("marketplace-component/src/components/category/category-container.tsx file - line 214 - " + Date.now());
        return _this;
    }
    CategoryContainer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var categoryRes;
            return __generator(this, function (_a) {
                categoryRes = this.props.fetchData[1];
                this.sendPageViewBi(categoryRes);
                return [2 /*return*/];
            });
        });
    };
    CategoryContainer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var categoryChanged, useInReview, subCategoriesChanged, categoryRes;
            var _this = this;
            return __generator(this, function (_a) {
                categoryChanged = this.props.slug !== prevProps.slug;
                useInReview = this.props.experiments &&
                    this.props.experiments.enabled('specs.marketplace.UseInReview');
                subCategoriesChanged = (this.props.subCategories || []).join('') !==
                    (prevProps.subCategories || []).join('');
                if (categoryChanged || subCategoriesChanged) {
                    if (subCategoriesChanged &&
                        this.props.subCategories &&
                        this.props.subCategories.length > 0) {
                        this.props.reFetch(function () {
                            return Promise.all([
                                getCategoriesData(_this.props.locale),
                                getTagsDataBySlugs([_this.props.slug], useInReview, _this.props.locale, _this.props.countryCode, true, true),
                                getTagsDataBySlugs(_this.props.subCategories, useInReview, _this.props.locale, _this.props.countryCode, true, true),
                            ]);
                        });
                    }
                    else {
                        this.props.reFetch(function () {
                            return Promise.all([
                                getCategoriesData(_this.props.locale),
                                getTagsDataBySlugs([_this.props.slug], useInReview, _this.props.locale, _this.props.countryCode, true, true),
                            ]);
                        });
                    }
                    categoryRes = this.props.fetchData[1];
                    this.sendPageViewBi(categoryRes);
                    this.setState({ isFetchingData: FetchStatus.COMPLETE });
                }
                return [2 /*return*/];
            });
        });
    };
    CategoryContainer.prototype.render = function () {
        console.log("marketplace-component/src/components/category/category-container.tsx file - line 312 - " + Date.now());
        var categoriesListRes = this.props.fetchData[0];
        var categoryRes = this.props.fetchData[1];
        var subCategoriesRes = this.props.fetchData.length === 2
            ? this.props.fetchData[1]
            : this.props.fetchData[2];
        var categoryProps = dtoToCategoryProps(categoryRes, subCategoriesRes, categoriesListRes, this.props.t);
        return (React.createElement(React.Fragment, null,
            React.createElement(Category, __assign({}, categoryProps))));
    };
    CategoryContainer = __decorate([
        withExperiments,
        withMarketplaceStore
    ], CategoryContainer);
    return CategoryContainer;
}(React.Component));
//# sourceMappingURL=category-container.js.map